import apiConfig from "constants/apiConfig"
import { CollaborationChatRoom } from "types/collaboration/chat";
import axiosClient from "utils/axiosClient"

let inFlightFirebaseTokenRequest: Promise<string> | null = null;

export const getBackendTokenForFirebase = async (): Promise<string> => {
    if (inFlightFirebaseTokenRequest) {
        return inFlightFirebaseTokenRequest;
    }

    inFlightFirebaseTokenRequest = (async () => {
        try {
            const response = await axiosClient.post(apiConfig.CREATE_FIREBASE_TOKEN.url);
            return response.data.token;
        } catch (error) {
            console.error("Failed to fetch firebase custom token", error);
            throw error;
        } finally {
            inFlightFirebaseTokenRequest = null;
        }
    })();

    return inFlightFirebaseTokenRequest;
}

export const getCollabChatRoom = async (
    campaignId: string,
    collaborationId: string
): Promise<CollaborationChatRoom> => {
    const response = await axiosClient.post(
        apiConfig.COLLAB_CHAT_ROOM.url
            .replace('<campaignId>', campaignId)
            .replace('<collaborationId>', collaborationId)
    )
    return response.data;
}
